import { MessageCircle } from 'lucide-react'
import useFormatPrice from '@hooks/useFormatPrice'
import UseWhatsapp from 'whatsapp-react-component'
import SocialLinks from '@components/SocialLinks'
import styles from '@styles/OfferPage.module.css'
import TermsModal from '@components/TermsModal'
import { useOffer } from '@hooks/useOffer'
import Loading from '@components/Loading'
import Navbar from '@components/Navbar'
import { useState } from 'react'

const OfertasPage = () => {
  const [selectedOffer, setSelectedOffer] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [buyAction, setBuyAction] = useState(null)
  const { offers, loading, error } = useOffer(true)
  const formatPrice = useFormatPrice()

  if (loading) return <Loading />

  const openModal = (offer, action) => {
    setSelectedOffer(offer)
    setBuyAction(action)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedOffer(null)
    setBuyAction(null)
  }

  const handleAcceptTerms = () => {
    if (buyAction === 'whatsapp') {
      const whatsappNumber = '573223110646'
      const greeting =
        '¡Hola! Estoy interesado en la siguiente oferta:\n\n'
      const message = 
            `📦 *Oferta:* ${selectedOffer.title}\n` +
            `📝 *Porcentaje Descuento:* ${selectedOffer.discountPercentage}%\n` +
            `💰 *Precio sin Descuento:* ${formatPrice(selectedOffer.originalPrice)}\n` +
            `💸 *Precio con Descuento:* ${formatPrice(selectedOffer.discountedPrice)}` +
            `\n\n💳 *Total del pedido:* ${formatPrice(selectedOffer.discountedPrice)}`
      const fullMessage = `${greeting}${message}`
      UseWhatsapp(whatsappNumber, fullMessage)
    } 
    closeModal()
  }

  if (error) {
    return (
      <div className={styles.ofertasPage}>
        <Navbar className={styles.ofertasNavbar} />
        <main className={styles.mainContent}>
          <h1 className={styles.title}>Ofertas Especiales</h1>
          <p className={styles.errorMessage}>{error}</p>
        </main>
        <footer className={styles.footer}>
          <SocialLinks />
        </footer>
      </div>
    )
  }

  return (
    <div className={styles.ofertasPage}>
      <Navbar className={styles.ofertasNavbar} />
      <main className={styles.mainContent}>
        <h1 className={styles.title}>Ofertas Especiales</h1>

        {offers.map((offer, index) => (
          <div key={offer.id} className={styles.ofertaCard}>
            <div className={styles.ofertaImage}>
              <img loading={index === 0 ? 'eager' : 'lazy'} src={offer.image.url || offer.image} alt={offer.title} />
              <span className={styles.discountBadge}>-{offer.discountPercentage}%</span>
            </div>
            <div className={styles.ofertaDetails}>
              <h2 className={styles.ofertaTitle}>{offer.title}</h2>
              <p className={styles.ofertaDescription}>{offer.description}</p>
              <div className={styles.priceContainer}>
                <span className={styles.originalPrice}>{formatPrice(offer.originalPrice)}</span>
                <span className={styles.discountedPrice}>{formatPrice(offer.discountedPrice)}</span>
              </div>
              <div className={styles.buttonContainer}>
                <button className={styles.whatsappButton} onClick={() => openModal(offer, 'whatsapp')}>
                  <MessageCircle size={20} />
                  Comprar por WhatsApp
                </button>
              </div>
            </div>
          </div>
        ))}

        {offers.length === 0 && <p className={styles.noOffersMessage}>No hay ofertas disponibles en este momento.</p>}
      </main>
      <footer className={styles.footer}>
        <SocialLinks />
      </footer>
      <TermsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onAccept={handleAcceptTerms}
        productTitle={selectedOffer?.title}
      />
    </div>
  )
}

export default OfertasPage

